module.exports = __webpack_public_path__ + "static/media/ausgellt-2.e0ccba40.png";